import Icon from '../components/Icon.vue'

Icon.register({
  'teeth-open': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 0H96C43 0 0 43 0 96V160C0 195.3 28.7 224 64 224H576C611.3 224 640 195.3 640 160V96C640 43 597 0 544 0zM160 176C160 184.8 152.8 192 144 192H80C71.2 192 64 184.8 64 176V144C64 117.5 85.5 96 112 96S160 117.5 160 144V176zM304 176C304 184.8 296.8 192 288 192H208C199.2 192 192 184.8 192 176V120C192 89.1 217.1 64 248 64S304 89.1 304 120V176zM448 176C448 184.8 440.8 192 432 192H352C343.2 192 336 184.8 336 176V120C336 89.1 361.1 64 392 64S448 89.1 448 120V176zM576 176C576 184.8 568.8 192 560 192H496C487.2 192 480 184.8 480 176V144C480 117.5 501.5 96 528 96S576 117.5 576 144V176zM576 320H64C28.7 320 0 348.6 0 384V416C0 469 43 512 96 512H544C597 512 640 469 640 416V384C640 348.6 611.3 320 576 320zM160 400C160 426.5 138.5 448 112 448S64 426.5 64 400V368C64 359.2 71.2 352 80 352H144C152.8 352 160 359.2 160 368V400zM304 392C304 422.9 278.9 448 248 448S192 422.9 192 392V368C192 359.2 199.2 352 208 352H288C296.8 352 304 359.2 304 368V392zM448 392C448 422.9 422.9 448 392 448S336 422.9 336 392V368C336 359.2 343.2 352 352 352H432C440.8 352 448 359.2 448 368V392zM576 400C576 426.5 554.5 448 528 448S480 426.5 480 400V368C480 359.2 487.2 352 496 352H560C568.8 352 576 359.2 576 368V400z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/teeth-open.js
// module id = je/G
// module chunks = 144